import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getEquipmentFormBuilderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.equipmentFromList(action.payload),
		);
		yield put({
			type: types.GET_EQUIPMENTFORMLIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EQUIPMENTFORMLIST_ERROR,
			payload,
		});
	}
}

export function* getEquipmentFormBuilderWatcherSaga() {
	yield takeLatest(
		types.GET_EQUIPMENTFORMLIST_START,
		getEquipmentFormBuilderHandlerSaga,
	);
}

//get/id

//create
